import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class PassReceivers extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.do('avoidFewPassReceivers', isChecked));
    }

    render() {
        const {lineupsFilter} = this.props;
        const isChecked = lineupsFilter.avoidFewPassReceivers;

        return (
            <div>
                <InputCheckbox
                    label="Disallow more than one pass catcher (TE, WR) from the same team unless the QB from that team is being used in the lineup"
                    checked={isChecked}
                    onChange={::this.onChange}
                />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {filters},
    } = state;

    return {
        lineupsFilter: filters,
    };
}

export default connect(mapStatesToProps)(PassReceivers);
